import { render, staticRenderFns } from "./PoolName.vue?vue&type=template&id=40f07444&"
import script from "./PoolName.vue?vue&type=script&lang=js&"
export * from "./PoolName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f07444')) {
      api.createRecord('40f07444', component.options)
    } else {
      api.reload('40f07444', component.options)
    }
    module.hot.accept("./PoolName.vue?vue&type=template&id=40f07444&", function () {
      api.rerender('40f07444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/pool/components/PoolName.vue"
export default component.exports